import { Input, InputProps } from '@chakra-ui/react'

export default Input

export type { InputProps }
